import { ModelError } from './ModelError';

export const BAD_REQUEST_ERROR_NAME = 'BAD_REQUEST_ERROR';

export class BadRequestError extends ModelError {
  public readonly name: string = BAD_REQUEST_ERROR_NAME;
}
